import { ATTACHMENT_FIELD, DATE_FIELD, QUESTION_FIELD, SELECT_FIELD, SIGNING_FIELD } from 'constants/editors';
import { BlockFormatType } from 'types/Editor';

export const getIsAttachmentField = (type?: BlockFormatType) => type === ATTACHMENT_FIELD;
export const getIsQuestionField = (type?: BlockFormatType) => type === QUESTION_FIELD;
export const getIsDateField = (type?: BlockFormatType) => type === DATE_FIELD;
export const getIsSignatureField = (type?: BlockFormatType) => type === SIGNING_FIELD;
export const getIsSelectField = (type?: BlockFormatType) => type === SELECT_FIELD;

export default undefined;